function serializeForm(data: any): any {
    if (data instanceof FormData || data instanceof URLSearchParams) return data;
    const body = new URLSearchParams();
    for (const key of Object.keys(data || {})) {
        const value = data[key];
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) {
            for (const item of value) body.append(key, String(item));
        } else {
            body.append(key, String(value));
        }
    }
    return body;
}

async function parseResponse(response: Response) {
    const text = await response.text();
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}

function parseXhrResponse(xhr: XMLHttpRequest) {
    const text = xhr.responseText || "";
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}

export default class Wiz {
    public namespace: any;
    public baseuri: any;

    constructor(baseuri: any) {
        this.baseuri = baseuri;
    }

    public app(namespace: any) {
        let instance = new Wiz(this.baseuri);
        instance.namespace = namespace;
        return instance;
    }

    public dev() {
        let findcookie = (name) => {
            let ca: Array<string> = document.cookie.split(';');
            let caLen: number = ca.length;
            let cookieName = `${name}=`;
            let c: string;

            for (let i: number = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');
                if (c.indexOf(cookieName) == 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return '';
        }

        let isdev = findcookie("season-wiz-devmode");
        if (isdev == 'true') return true;
        return false;
    }

    public project() {
        let findcookie = (name) => {
            let ca: Array<string> = document.cookie.split(';');
            let caLen: number = ca.length;
            let cookieName = `${name}=`;
            let c: string;

            for (let i: number = 0; i < caLen; i += 1) {
                c = ca[i].replace(/^\s+/g, '');
                if (c.indexOf(cookieName) == 0) {
                    return c.substring(cookieName.length, c.length);
                }
            }
            return '';
        }

        let project = findcookie("season-wiz-project");
        if (project) return project;
        return "main";
    }

    public async socket() {
        const { io } = await import("socket.io-client");
        let socketns = this.baseuri + "/app/" + this.project();
        if (this.namespace)
            socketns = socketns + "/" + this.namespace;
        return io(socketns);
    };

    public url(function_name: string) {
        if (function_name[0] == "/") function_name = function_name.substring(1);
        return this.baseuri + "/api/" + this.namespace + "/" + function_name;
    }

    public call(function_name: string, data: any = {}, options: any = {}) {
        const url = this.url(function_name);
        const method = options.type || "POST";
        const body = serializeForm(data);

        if (typeof options.xhr === "function") {
            return new Promise((resolve) => {
                const xhr: XMLHttpRequest = options.xhr();
                xhr.open(method, url, true);
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === XMLHttpRequest.DONE) {
                        resolve(parseXhrResponse(xhr));
                    }
                };
                if (!(body instanceof FormData) && options.contentType !== false) {
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
                xhr.send(method === "GET" ? null : body);
            });
        }

        return fetch(url, {
            method: method,
            body: method === "GET" ? null : body,
            credentials: "same-origin",
            headers: (!(body instanceof FormData) && options.contentType !== false)
                ? { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" }
                : undefined,
        }).then(parseResponse).catch((error) => {
            return { code: 0, data: { message: error?.message || "request failed" } };
        });
    }
}
